import Vue from 'vue'

const studentLeave = {
    state: {
        id: null,
        dialogEnterDetails: false,
    },
    mutations: {
        CHANGE_DETAIL_DIALOG: (state, status) => {
            state.dialogEnterDetails = status;
        },
        SET_ENTER_ID: (state, id) => {
            console.log(id)
            state.id = id
        }
    }
  }
  
  export default studentLeave


// WEBPACK FOOTER //
// ./src/store/modules/notificationManagement/studentLeaveList.js